

import { Component, Prop, Mixins } from "vue-property-decorator";
import IBPaymentCardActionCaller from "@/components/IBPayment/mixins/IBPaymentCardActionCaller";
import IBPaymentCardColor from "@/components/IBPayment/mixins/IBPaymentCardColor";
import IBPaymentCardIconState from "@/components/IBPayment/mixins/IBPaymentCardIconState";
import { IPaymentCardContentIcon, IChip, TText } from "@/components/IBPayment/interface";

@Component
export default class IBStatusAlert extends Mixins(
	IBPaymentCardActionCaller,
	IBPaymentCardColor,
	IBPaymentCardIconState
) {

	@Prop(Object)
	readonly icon!: IPaymentCardContentIcon

	@Prop({ type: Array, default: () => [] })
	readonly chips!: IChip[]

	@Prop(String)
	readonly subTitle!: TText

}

